import {useHeaderInMemoryCacheClient} from './useHeaderInMemoryCache.client';
import {useHeaderInMemoryCacheServer} from './useHeaderInMemoryCache.server';

export const useHeaderInMemoryCache = process.browser
  ? useHeaderInMemoryCacheClient
  : useHeaderInMemoryCacheServer;
